import { Loading } from '@geist-ui/react'
import { useAtom } from 'jotai'
import { useEffect } from 'react'
import { animated, useSpring } from 'react-spring'
import styled from 'styled-components'
import { fadeAtom } from './atoms'

/*======================== React component ===================================*/

const WhiteFlash = (): JSX.Element => {
  const [fade] = useAtom(fadeAtom)
  const [styles, api] = useSpring(() => ({ opacity: 0, pointerEvents: 'none' }))

  useEffect(() => {
    api.start(
      fade
        ? { opacity: 1, pointerEvents: 'all', config: { duration: 200 } }
        : { opacity: 0, pointerEvents: 'none', config: { duration: 200 } }
    )
  }, [fade, api])

  return (
    <AnimatedWhite style={styles}>
      <Centered>
        <Loading spaceRatio={2.5} color="white" />
      </Centered>
    </AnimatedWhite>
  )
}

export default WhiteFlash

/*======================== Styled components =================================*/

const White = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: black;
  z-index: 500;
`

const Centered = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 501;
  height: 100%;
  width: 100%;
`

const AnimatedWhite = animated(White)
